import {Component, Input, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {createQuote} from "../../actions/quote.action";
import * as fromQuote from '../../reducers/index';
import * as quoteActions from '../../actions/quote.action';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Quote, QuoteConstants} from '../../model/quote';

@Component({
    selector: 'create-new-quote',
    templateUrl: './create-new-quote.component.html',
    styleUrls: ['./create-new-quote.component.scss']
})

export class CreateNewQuoteCompoennt implements OnInit {
    userInput: string;
    form: FormGroup;

    constructor(private store: Store<fromQuote.State>) {}

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl("", [
                Validators.required,
                Validators.minLength(QuoteConstants.NAME_MIN_LENGTH),
                Validators.maxLength(QuoteConstants.NAME_MAX_LENGTH)
            ])
        });
    }

    onCreateQuote() {
        this.store.dispatch(createQuote({command: {name: this.form.value.name}}));
        this.closeCreateQuote();
    }

    closeCreateQuote() {
        this.store.dispatch(quoteActions.closeCreateNewQuote());
    }
}
